import ComicCard from './ComicCard';
import { featuredComics, categoriesHot } from '@/mocks/comics';

export default function DailyPicks() {
  return (
    <section id="daily" className="w-full bg-background-950 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400">
              <i className="ri-star-fill" />
              DAILY PICKS
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
              今日编辑精选
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-400 md:text-base">
              编辑部人工筛选的今日最值得追作品，综合剧情、画风与更新稳定度，跟着选准没错。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {categoriesHot.slice(0, 3).map((tag) => (
              <a
                key={tag}
                href="#category"
                className="inline-flex items-center gap-1 rounded-full border border-background-800 bg-background-900 px-3 py-1.5 text-xs text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300"
              >
                <i className="ri-price-tag-3-line text-[11px] text-secondary-400" />
                {tag}
              </a>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>

      {/* 滚动跑马灯 */}
      <div className="mt-14 w-full overflow-hidden border-y border-background-800 bg-background-900/50 py-3">
        <div className="flex w-max animate-ticker whitespace-nowrap">
          {[0, 1].map((n) => (
            <div key={n} className="flex items-center">
              {featuredComics.map((comic) => (
                <a
                  key={`${n}-${comic.id}`}
                  href="#booklist"
                  className="mx-6 inline-flex items-center gap-2 text-sm text-foreground-300 transition-colors hover:text-primary-300"
                >
                  <i className="ri-fire-fill text-base text-accent-400" />
                  <span className="font-medium">{comic.title}</span>
                  <span className="text-foreground-500">{comic.genre}</span>
                </a>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}